'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupUsersView$$anon$11(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_GroupUsersView$$anon$11 as $c_Lpresto_GroupUsersView$$anon$11 };
$p = $c_Lpresto_GroupUsersView$$anon$11.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupUsersView$$anon$11;
/** @constructor */
function $h_Lpresto_GroupUsersView$$anon$11() {
}
export { $h_Lpresto_GroupUsersView$$anon$11 as $h_Lpresto_GroupUsersView$$anon$11 };
$h_Lpresto_GroupUsersView$$anon$11.prototype = $p;
$p.bh = (function(_$16) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(_$16, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$17) => _$17.f1)), $j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().r5());
});
var $d_Lpresto_GroupUsersView$$anon$11 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupUsersView$$anon$11, "presto.GroupUsersView$$anon$11", ({
  Jj: 1,
  H: 1
}));
export { $d_Lpresto_GroupUsersView$$anon$11 as $d_Lpresto_GroupUsersView$$anon$11 };
//# sourceMappingURL=presto.-Group-Users-View$$anon$11.js.map
